import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-plan-detail',
  templateUrl: './plan-detail.component.html',
  styleUrls: ['./plan-detail.component.scss']
})
export class PlanDetailComponent implements OnInit {
  @Input() subscriptionPlan;
  @Input() cameraPlan;
  @Input() spacePlan;
  constructor() { }

  ngOnInit() {
  }

}
